import ContentButton from "../buttons/ContentButton";
import "./DownloadWarningBox.css";

const DownloadWarningBox = ({children}) => {
    return (
        <main className="warning-box">
            <div className="warning-box-content">
                <p>
                    {children}
                </p>
            </div>
        </main>
    );
}

export default DownloadWarningBox;